/**
 * 无归属服务端错误 toast（21f）。
 *
 * 对应旧版 `chat_screen.dart` 的 `_handleRealtimeError` 中「uuid 为空」那一支：
 * error_msg 没匹配上在途发送/编辑、也没回滚在途置顶时，旧版 `ScaffoldMessenger`
 * 弹原文。新版此前整条丢弃，用户侧完全静默——这就是人工反馈「错误提示都隐藏了」。
 *
 * 有归属的错误不走这里：发送失败在失败气泡上显示原文（MessageList.FailedActions）、
 * 编辑失败在 ChatPage 的 editTip、置顶失败在 pinFailedSeq。
 *
 * 挂在 App 根（与 UpdateBanner/NotifyPopups 同级）：这类错误与当前页面无关，
 * 聊天页没打开时也要能看到。
 */
import { useEffect, useRef, useState } from 'preact/hooks';
import { useGlobal } from '~/store/useGlobal';
import styles from './serverErrorToast.module.scss';

const TOAST_MS = 3500;

export function ServerErrorToast() {
  const { seq, message } = useGlobal((s) => s.serverError);
  const [text, setText] = useState('');
  const timerRef = useRef(0);
  // seq 变化才是事件（editFailedSeq 同口径）：首帧 seq=0 不弹
  useEffect(() => {
    if (seq === 0 || message === '') return;
    setText(message);
    clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setText(''), TOAST_MS);
  }, [seq, message]);
  useEffect(() => () => clearTimeout(timerRef.current), []);
  if (text === '') return null;
  return (
    <div className={styles.toast} role="alert" data-testid="server-error-toast">
      {text}
    </div>
  );
}
